/**
 * @file ShopUserRowActions.tsx
 * @description Действия в строке сотрудника магазина (phase08.5 shadcn).
 */

import { ShieldUser } from "lucide-react";
import { useState } from "react";

import { UserContextsEditor } from "../../components/UserContextsEditor";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../components/ui/tooltip";
import type { AdminUser } from "../../lib/api-admin-users";

interface Props {
  user: AdminUser;
  shop: { id: string; slug: string; displayName: string };
  onChanged: (u: AdminUser) => void;
}

export function ShopUserRowActions({ user, shop, onChanged }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-end gap-1">
        <Tooltip>
          <TooltipTrigger
            render={(props) => (
              <Button
                {...props}
                variant="ghost"
                size="icon-sm"
                onClick={() => setOpen(true)}
                aria-label="Контексты сотрудника"
              >
                <ShieldUser className="size-4" />
              </Button>
            )}
          />
          <TooltipContent>Контексты сотрудника</TooltipContent>
        </Tooltip>
      </div>

      <Dialog open={open} onOpenChange={(o) => !o && setOpen(false)}>
        <DialogContent fullScreen className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Контексты: {user.email}</DialogTitle>
          </DialogHeader>
          <UserContextsEditor
            user={user}
            scope={{
              scope: "shop",
              shopId: shop.id,
              shopDisplayName: shop.displayName,
            }}
            onChanged={(u) => {
              onChanged(u);
              setOpen(false);
            }}
          />
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>
              Закрыть
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
